import { Row, Col, Container } from "react-bootstrap";
import ProfileItem from "./ProfileItem";
import pablodifilippo from "../../../assets/team/profiles/pablodifilippo.png";
import pabloAleman from "../../../assets/team/profiles/pabloAleman.png";
import emilianoCubisino from "../../../assets/team/profiles/emilianoCubisino.png";
import yamileMasmut from "../../../assets/team/profiles/yamileMasmut.png";
import damianConstantino from "../../../assets/team/profiles/damianConstantino.png";
import cristianMarucci from "../../../assets/team/profiles/cristianMarucci.png";
import fernandoRovaletti from "../../../assets/team/profiles/fernandoRovaletti.png";
import pabloAlvarez from "../../../assets/team/profiles/pabloAlvarez.png";
import soledadQuijano from "../../../assets/team/profiles/soledadQuijano.png";
import martinTonelli from "../../../assets/team/profiles/martinTonelli.png";
// import ginoGentile from "../../../assets/team/profiles/ginoGentile.png"; // no se usa
import mauroZicarelli from "../../../assets/team/profiles/mauroZicarelli.png";
import julianGaleano from "../../../assets/team/profiles/julianGaleano.png";
import blash from "../../../assets/team/profiles/blash.png";
import catalinaFagundez from "../../../assets/team/profiles/team_wopandpartners_catalinafagundezsaldaña.png";
import gonzaloArocha from "../../../assets/team/profiles/team_wopandpartners_gonzaloarocha.png";
import camilaDegiorgis from "../../../assets/team/profiles/team_wopandpartners_camiladegiorgis.png";
import olgaVillegas from "../../../assets/team/profiles/team_wopandpartners_olgavillegasfernández.png";
import marioBallesteros from "../../../assets/team/profiles/team_wopandpartners_marioballesteros.png";

const profiles = [
  {
    img: pablodifilippo,
    name: "Pablo Di Filippo",
    title: "CEO",
    link: "https://www.linkedin.com/in/pablodif/",
  },
  {
    img: pabloAleman,
    name: "Pablo Aleman",
    title: "Business Director",
    link: "https://www.linkedin.com/in/pablo-fernando-alem%C3%A1n/",
  },
  {
    img: yamileMasmut,
    name: "Yamile Masmut",
    title: "Digital Client Strategist",
    link: "https://www.linkedin.com/in/yamile-masmut/",
  },
  {
    img: emilianoCubisino,
    name: "Emiliano Cubisino",
    title: "Senior Creative Designer",
    link: "https://www.linkedin.com/in/emiliano-cubisino-897b00242/",
  },
  {
    img: damianConstantino,
    name: "Damián Costantino",
    title: "Senior Graphic Designer",
    link: "https://www.linkedin.com/in/dami%C3%A1n-costantino-211140113/",
  },
  {
    img: catalinaFagundez,
    name: "Catalina Fagundez Saldaña",
    title: "Content Strategist | Digital Channels",
    link: "https://www.linkedin.com/in/catalinafagundezsalda%C3%B1a/",
  },
  {
    img: gonzaloArocha,
    name: "Gonzalo Arocha",
    title: "Business Analyst",
    link: "https://www.linkedin.com/in/gonzaloarocha/",
  },
  {
    img: camilaDegiorgis,
    name: "Camila Degiorgis",
    title: "Graphic Designer",
    link: "https://www.linkedin.com/in/camila-degiorgis-582a3926a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
  },
  {
    img: cristianMarucci,
    name: "Cristian Marucci",
    title: "Head of Development\n\rAvradev\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/cristianmarucci/",
  },
  {
    img: fernandoRovaletti,
    name: "Fernando Rovaletti",
    title: "Art Director\n\rTanque Design\n\r- Wop Partner -",
    link: "https://ar.linkedin.com/in/fernando-a-rovaletti-19336132",
  },
  {
    img: pabloAlvarez,
    name: "Pablo Álvarez",
    title: "Creative Director\n\rTanque Design\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/pabloalvarezespin/",
  },
  {
    img: soledadQuijano,
    name: "Soledad Quijano",
    title: "Press\n\rPartnerpress\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/soledadquijano",
  },
  {
    img: martinTonelli,
    name: "Martín Tonelli",
    title: "Digital Analytics\n\rCrabsense\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/martintonelli",
  },
  {
    img: blash,
    name: "Blas Herrera",
    title: "Head of Adtech\n\rCrabsense\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/blasherrera",
  },
  {
    img: mauroZicarelli,
    name: "Mauro Zicarelli",
    title: "Business Strategy\n\rDelenio\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/maurozicarelli",
  },
  {
    img: julianGaleano,
    name: "Julián Galeano",
    title: "Audiovisual Producer\n\rPraset\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/juliangaleanook",
  },
  {
    img: olgaVillegas,
    name: "Olga Villegas Fernández",
    title: "Directora Creativa\n\rToro Pinto\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/olga-villegas-fern%C3%A1ndez-62a86114/",
  },
  {
    img: marioBallesteros,
    name: "Mario Ballesteros",
    title: "Art Director\n\rToro Pinto\n\r- Wop Partner -",
    link: "https://www.linkedin.com/in/mario-hgno-b-6ba67139/",
  },
];

const ProfileList = () => {
  return (
    <Container>
      <Row>
        <Col md={8} xs={12} className="pb-5 mx-auto">
          <Row className="d-flex justify-content-center">
            {profiles &&
              profiles.length > 0 &&
              profiles.map((v) => (
                <Col md={3} xs={6} key={v.name}>
                  <ProfileItem img={v.img} name={v.name} title={v.title} link={v.link} />{" "}
                </Col>
              ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default ProfileList;

